const $html = $('html');

export const IS_EGON_VALIDATION = $html.data('egon-validation');
export const IS_EGON_VALIDATION__ZIP_BASED = $html.data('egon-zip-base');
export const IS_VERIFALIA_VALIDATION = $html.data('verifalia-validation');
